



















































import { Component, Prop, Vue } from "vue-property-decorator";
import ChangeNameDialog from "./ChangeNameDialog.vue";
import ViewUserDialog from "./ViewUserDialog.vue";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import { IAction } from "../common/CommonTypes";
import { GroupModel, GroupsApi, UserModel } from "../../../apis";
import { DataTableHeader } from "vuetify";

export enum ACTION {
  VIEW_PERMISSIONS = "VIEW_PERMISSIONS",
  VIEW_USERS = "VIEW_USERS",
  CHANGE_NAME = "CHANGE_NAME",
}
@Component({
  components: {
    ChangeNameDialog,
    ViewUserDialog,
    MoreVertBtn,
  },
})
export default class AdminGroupManagement extends Vue {
  get actions(): Array<IAction> {
    return [
      {
        titleStyle: "color: black; font-weight: 600",
        titleName: this.$t("text.viewPermissions"),
        action: ACTION.VIEW_PERMISSIONS,
        permission: { context: "GROUP_MANAGEMENT", action: "read" },
      },
      {
        titleStyle: "color: black; font-weight: 600",
        titleName: this.$t("text.viewUsers"),
        action: ACTION.VIEW_USERS,
        permission: { context: "GROUP_MANAGEMENT", action: "read" },
      },
      {
        titleStyle: "color: black; font-weight: 600",
        titleName: this.$t("text.changeName"),
        action: ACTION.CHANGE_NAME,
        permission: { context: "GROUP_MANAGEMENT", action: "update" },
      },
    ];
  }
  showDialog = false;
  selectedGroup: GroupModel | null = null;
  groups: GroupModel[] = [];
  users: UserModel[] = [];

  get HEADERS() {
    return [
      { text: this.$t("text.groupName"), value: "name", width: 200 },
      { text: this.$t("text.members"), value: "numberOfUsers" },
      { text: this.$t("text.updatedDate"), value: "updatedAt", width: 200 },
      { text: this.$t("text.action"), value: "action", width: 50 },
    ] as DataTableHeader[];
  }

  created() {
    this.getGroups();
  }

  async getGroups() {
    try {
      this.$util.showLoading();
      const rs = await new GroupsApi().getGroups();
      this.groups = rs.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onSelectedPermission({ item, action }): void {
    this.selectedGroup = { ...item };
    switch (action) {
      case ACTION.VIEW_PERMISSIONS: {
        this.onViewPermission();
        break;
      }
      case ACTION.VIEW_USERS: {
        this.isShowViewUsersDialog = true;
        this.onViewUsers();
        break;
      }
      case ACTION.CHANGE_NAME: {
        this.onChangeName();
        break;
      }
      default: {
        break;
      }
    }
  }

  isShowViewUsersDialog = false;
  isShowChangeNameDialog = false;
  onViewPermission() {
    const id = this.selectedGroup.id;
    return this.$router.push({ path: `/users/groups/${id}` });
  }

  onViewUsersSaved() {
    this.onViewUsers();
  }

  onChangeName() {
    this.isShowChangeNameDialog = true;
  }

  onChangeNameSaved() {
    this.getGroups();
  }

  onChangeNameCancelled() {
  }

  async onViewUsers() {
    const rs = await new GroupsApi().getUsersByGroup({
      id: this.selectedGroup.id,
    });
    if (rs.data.data && rs.data.data.length > 0) {
      this.users = rs.data.data[0].users;
    }
  }

  onViewUsersCancelled() {
    this.getGroups();
  }

  unSelectedPermission() {
    this.selectedGroup = null;
  }
}
